<script lang="ts">
	import { format } from 'svelte-i18n';

	//Services
	import { open_external_link_android } from '../../../services/native_container_requests_android';
	import { open_external_link } from '../../../services/native_container_requests_ios';
	//Stores
	import { os, app } from 'src/stores/session/native-bridge';
	//Design system components
	import { Text } from '@Shelly/shelly-design-system';

	export let ip: string | boolean;
	export let ssid: string | boolean;

	const navigateToLocal = () => {
		//if user isn't host owner prevent navigation because not able to get nothing
		if (typeof ip == 'string' && /\d/gi.test(ip)) {
			if ($app) {
				if ($os === 'IOS') {
					open_external_link(`http://${ip}`);
				} else {
					open_external_link_android(`http://${ip}`);
				}
			} else {
				window.open(`http://${ip}`);
			}
		}
	};
</script>

<Text styleType="body-small">
	{#if ssid && typeof ssid === 'string'}
		<slot>
			<span class="text-bold">SSID</span><span class="text-bold"> : </span>
		</slot>
		<span class="text-small">{ssid}</span>
	{/if}
</Text>

<Text styleType="body-small">
	<slot>
		<span class="text-bold">IP</span><span class="text-bold"> : </span>
	</slot>
	<span role="presentation" class="link-styles text-small" on:click|stopPropagation={navigateToLocal}
		>{ip}</span
	>
</Text>
